import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '../contexts/SubscriptionContext';
import PlanSelectionModal from './PlanSelectionModal';
import { Lock, Crown } from 'lucide-react';

const PremiumGate = ({ featureName = 'This feature' }) => {
  const { plans } = useSubscription();
  const [open, setOpen] = useState(false);

  const monthly = plans.find((p) => p.plan_type === 'monthly');
  const annual = plans.find((p) => p.plan_type === 'annual');

  return (
    <>
      <div
        className="flex items-center justify-center py-12 px-4"
        data-testid="premium-gate"
      >
        <div className="max-w-lg w-full text-center rounded-2xl border border-amber-500/30 bg-gradient-to-b from-slate-800 to-slate-900 p-6 sm:p-10 shadow-2xl">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-400/15 mb-5">
            <Lock className="h-8 w-8 text-amber-400" />
          </div>
          <h2 className="text-xl sm:text-2xl font-extrabold text-white">
            {featureName} requires Option Wizard Premium
          </h2>
          <p className="text-sm sm:text-base text-slate-300 mt-3">
            Unlock all advanced options analysis, scanners, AI analysis, portfolio tools and more.
          </p>
          <div className="flex flex-wrap items-end justify-center gap-x-2 gap-y-1 mt-5">
            <span className="text-3xl font-extrabold text-amber-400">${monthly?.price ?? '19.99'}</span>
            <span className="text-slate-400 mb-1">/mo</span>
            <span className="text-slate-500 ml-2">or ${annual?.price ?? '99.99'}/yr</span>
          </div>
          <p className="text-xs text-amber-400/80 mt-1">Includes a 1-day free trial</p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
            <Button
              onClick={() => setOpen(true)}
              className="bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-slate-900 font-bold px-6 h-11"
              data-testid="gate-subscribe-btn"
            >
              <Crown className="h-4 w-4 mr-2" /> Subscribe Now
            </Button>
            <Button
              onClick={() => setOpen(true)}
              variant="outline"
              className="border-amber-400/40 text-amber-300 hover:bg-amber-400/10 h-11 px-6"
              data-testid="gate-view-plans-btn"
            >
              View Plans
            </Button>
          </div>
        </div>
      </div>
      <PlanSelectionModal open={open} onOpenChange={setOpen} />
    </>
  );
};

export default PremiumGate;
